import React, { Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'dva';
import Select from '@mos-front-components/public/es/components/MosSelect/MosSelect';

import {
  ADDRESS_INFO_FIELD_NAME,
  areaSuggestions,
} from '../../../../constants/address';
import { getDistricts } from '../../../../helpers/address';
import AddressSpinner from '../AddressSpinner/AddressSpinner';
import {
  getArea,
  getDistrict,
  isFullViewVisible,
  isManualInputDisabled,
  isNewMoscow,
  PersonModel,
} from '../../../../selectors/addressUnmodeled';
import AddressSubsequentRequestError from '../AddressMessages/AddressSubsequentRequestError';
import AddressSubregionFields from '../AddressSubregionFields';
import AddressNewMoscowWarning from '../AddressMessages/AddressNewMoscowWarning';
import { getTextValue } from '../../../../constants/getFieldValues';
import { getAddressPlaceholder } from '../../../../helpers/getPlacelholder';
import { AddressFields } from '../../../../../types/address';

interface Props {
  onAddressChange(value, string, disabled): void;

  model: PersonModel;
  isVisible: boolean;
  area: AddressFields['area'];
  district: AddressFields['district'];
  isNewMoscow: boolean;
  isExpandedView: boolean;
  disabled: boolean;
}

const AddressInput = (props: Props): JSX.Element | null => {
  if (!props.isVisible) return null;
  const { onAddressChange, isNewMoscow, district, area, disabled } = props;

  return (
    <Fragment>
      <div className="PguFormGrid__row">
        <Select
          className="PguFormGrid__field PguFormGrid_col ym-hide-content"
          placeholder={getAddressPlaceholder('region')}
          value="Москва"
          name={ADDRESS_INFO_FIELD_NAME.region}
          suggestions={[]}
          onChange={() => {}}
          disabled
          dropListView
        />
      </div>
      <div className="PguFormGrid__row">
        <Select
          disabled={disabled}
          className="PguFormGrid__field PguFormGrid_col ym-hide-content"
          placeholder={getAddressPlaceholder('area')}
          value={getTextValue(area) || ''}
          name={ADDRESS_INFO_FIELD_NAME.area}
          suggestions={areaSuggestions}
          onChange={(val) => {
            onAddressChange(val, ADDRESS_INFO_FIELD_NAME.area, disabled);
          }}
          dropListView
          hasError={area.error}
        />
        <Select
          disabled={disabled}
          className="PguFormGrid__field PguFormGrid_col ym-hide-content"
          placeholder={
            isNewMoscow
              ? getAddressPlaceholder('settlement')
              : getAddressPlaceholder('district')
          }
          value={getTextValue(district) || ''}
          name={ADDRESS_INFO_FIELD_NAME.district}
          suggestions={getDistricts(area.value.text)}
          onChange={(val) => {
            onAddressChange(val, ADDRESS_INFO_FIELD_NAME.district, disabled);
          }}
          dropListView
          hasError={district.error}
        />
      </div>

      <AddressSubregionFields
        model={props.model}
        isExpandedView={props.isExpandedView}
      />
      <AddressSpinner model={props.model} forManualInput />
      <AddressSubsequentRequestError model={props.model} forManualInput />
      <AddressNewMoscowWarning model={props.model} />
    </Fragment>
  );
};

const mapStateToProps = createStructuredSelector({
  isVisible: isFullViewVisible,
  area: getArea,
  district: getDistrict,
  isNewMoscow,
  disabled: isManualInputDisabled,
});

function mapDispatchToProps(dispatch, { model }) {
  return {
    onAddressChange(value, addressField, disabled) {
      dispatch({
        type: `${model}/address/change`,
        payload: { [addressField]: value },
      });
      if (!disabled && !model.includes('child')) {
        dispatch({ type: 'form/saveDraft' });
      }
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressInput);
